import { createSlice } from '@reduxjs/toolkit';
import { performGlobalLogout } from './authSlice';

const initialState = {
	currentGame: null, // e.g., 'ANDAR_BAHAR' | 'AAA'
	roundId: null,
};

const gameSlice = createSlice({
	name: 'game',
	initialState,
	reducers: {
		setCurrentGame(state, action) {
			state.currentGame = action.payload || null;
		},
		setRoundId(state, action) {
			state.roundId = action.payload || null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(performGlobalLogout.fulfilled, (state) => {
				state.currentGame = null;
				state.roundId = null;
			});
	},
});

export const { setCurrentGame, setRoundId } = gameSlice.actions;
export default gameSlice.reducer;


